<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="praise">PRAISE FOR THE WRITING OF SARAH ZETTEL</h1>
<p class="center" style="margin-top:20px;"><i>RECLAMATION</i></p>
<p class="center">Winner of the Locus Award for Best First Novel</p>
<p class="noind" style="margin-top:20px;">“An exciting new talent . . . Ms. Zettel’s confident treatment of her ambitious material shows just how entertaining the ‘grand tradition of Heinlein and Asimov’ can be in her sympathetic hands.” —<i>The New York Times Book Review</i></p>
<p class="noind" style="margin-top:20px;">“This one has scope and sweep, intrigue and grandiose technologies, and grand adventure. Sarah Zettel is a writer to watch.” —<i>Analog Science Fiction &amp; Fact</i></p>
<p class="noind" style="margin-top:20px;">“In the grand tradition of Heinlein and Asimov . . . More than an exciting science fiction adventure story—it also gives us a universe, vividly imagined and thought provoking.” —Poul Anderson, author of <i>Harvest of Stan</i></p>
<p class="center" style="margin-top:20px;"><i>FOOL’S WAR</i></p>
<p class="center">A <i>New York Times</i> Notable Book of the Year</p>
<p class="noind" style="margin-top:20px;">“Wrenchingly real.” —<i>The Philadelphia Inquirer</i></p>
<p class="noind" style="margin-top:20px;">“This thought-provoking tale offers an energetic plot and a cast full of appealing characters.” —<i>The Plain Dealer</i></p>
<p class="noind" style="margin-top:20px;">“An exciting, stimulating and imaginative book. Zettel handles her intriguing cast of characters, both human and AI, with style and confidence.” —SF Reviews</p>
<p class="center" style="margin-top:20px;"><i>PLAYING GOD</i></p>
<p class="noind" style="margin-top:20px;">“Energetic and entertaining . . . with many clever twists.” —<i>The Plain Dealer</i></p>
<p class="noind" style="margin-top:20px;">“Absorbing and exciting . . . Rush right out and grab <i>Playing God.</i>” —<i>Analog Science Fiction &amp; Fact</i></p>
<p class="center" style="margin-top:20px;"><i>THE QUIET INVASION</i></p>
<p class="noind" style="margin-top:20px;">“Humans, aliens and Venus itself are all skillfully portrayed here, in a pleasingly complex plot. . . . A drama of considerable moral force.” —<i>Locus</i></p>
<p class="noind" style="margin-top:20px;">“A first-contact novel worth reading and relishing.” —<i>Publishers Weekly</i></p>
<p class="noind" style="margin-top:20px;">“Zettel demonstrates her gift for creating fully realized cultures. . . . A riveting confrontation.” —<i>Booklist</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2page.vue?74b2921e